import templates from "../templates";

import jQuery from "jquery";
import { EVENT } from "../data/constants";
import SERVICE_REGISTRY from "../services/registry";
import { LocationProvider } from "../stores-js/location/locationprovider";
import { SearchView } from "../stores-js/ui/searchview";
import {
    EventManager,
    addBrandIcon,
    concatenateStoreAddress,
    createLocalitiesTableView,
    createWoosmapLocalitiesAutoComplete,
    formatDistanceValue,
} from "../utils/global";

const $ = jQuery;

export default class DirectionsView extends woosmap.map.MVCObject {
    constructor(mainView) {
        super();
        this.selector = "#storemap-directionbar-container";

        this.mainView = mainView;

        this.mainElement = $(this.selector);
        this.mainElement.html(templates.mobile.direction.render(total.maps.L10n.ui));

        this.directions = [];

        // SearchView

        this.woosmapSearchView = new SearchView(
            templates.mobile.searchInputTop.render(total.maps.L10n.ui),
            "<span>{{name}}</span>",
        );
        this.mainElement.find(".storemap-inputbar-container").html(this.woosmapSearchView.getContainer());

        // PlaceSearch and TableView for prediction results
        // const googlePlaceAutocompleteOptions = {
        //   bounds: this.mainView.mapView.initialBounds,
        //   types: ['geocode'],
        // };

        // this.woosmapPlacesSearchSource = new woosmap.location.PlacesSearchSource(googlePlaceAutocompleteOptions, 3);

        const woosmapLocalitiesAutoComplete = createWoosmapLocalitiesAutoComplete(
            this.mainElement,
            "suggestionContainerClass",
        );

        // this.woosmapSugestionTableView = new woosmap.ui.TableView({
        //   cell_store: '<div></div>',
        //   cell_place: '<div class="storemap-suggestion-item">{{description}}</div>',
        // });

        this.woosmapSugestionTableView = createLocalitiesTableView();

        this.woosmapSugestionTableView.bindTo("predictions", woosmapLocalitiesAutoComplete);
        this.bindTo("predictions", woosmapLocalitiesAutoComplete);
        // this.bindTo('predictions', this.woosmapPlacesSearchSource);
        woosmapLocalitiesAutoComplete.bindTo("autocomplete_query", this.woosmapSearchView, false);
        woosmapLocalitiesAutoComplete.bindTo("detailsPlaces", this.woosmapSugestionTableView, "details", false);
        this.bindTo("location", this.woosmapSugestionTableView);

        this.mainElement.find(".storemap-suggestionbar-container").html(this.woosmapSugestionTableView.getContainer());

        // Geolocalisation
        const self = this;
        this.woosmapNavigatorGeolocation = new LocationProvider();
        // this.bindTo('location', this.woosmapNavigatorGeolocation);
        this.woosmapNavigatorGeolocation.location_changed = function () {
            const location = this.get("location");

            if (location && typeof location.source !== "undefined") {
                this.location.lat = Number.parseFloat(location.lat);
                this.location.lng = Number.parseFloat(location.lng);
                self.set("location", location);
            }
        };

        this.directionUserPosition = null;
        this.reverseOriginDestination = false;

        this._wireEvents();
    }

    _wireEvents() {
        const self = this;

        function onTravelModeSpanClick() {
            const selectedSpan = $(this);
            self.mainElement
                .find(".woosmap-travel-mode-option")
                .removeClass("selected")
                .removeClass("storemap-mode-selected");
            selectedSpan.addClass("storemap-mode-selected").addClass("selected");
            // self.woosmapDirectionsProvider.set("selectedTravelMode", selectedSpan.attr("data-travel-mode"));
            self.mainElement.find("#storemap-directionlistbar-container").empty();
            self.mainElement.find("#storemap-directionlistbar-message-container").hide();
            self.mainView.updateDirectionTravelMode(selectedSpan.attr("data-travel-mode"));
        }

        function onDirectionSummaryClick() {
            const summaryElement = $(this);
            const index = summaryElement.index();
            self.mainView.showMap("direction", index);
        }

        function toggleOriginDestination() {
            self.mainView.toggleOriginDestination();
            // total.maps.service.itinary.reverseOriginDestination();
        }

        function onReverseDirectionClick() {
            const storeOriginContainer = self.mainElement.find("#storemap-directionsearchbar-store-origin-container");
            const storeDestinationContainer = self.mainElement.find(
                "#storemap-directionsearchbar-store-destination-container",
            );
            const inputSearchLabel = self.mainElement.find(
                "#storemap-directionsearchbar-searchinput-container .storemap-inputbar-label",
            );
            const firstReverseButton = self.mainElement.find(
                ".storemap-directionsearchbar-reverse-button.first-reverse-button",
            );
            const secondReverseButton = self.mainElement.find(
                ".storemap-directionsearchbar-reverse-button.second-reverse-button",
            );

            if (storeOriginContainer.is(":visible")) {
                storeOriginContainer.hide();
                storeDestinationContainer.show();
                firstReverseButton.hide();
                secondReverseButton.show();
                self.reverseOriginDestination = false;
                inputSearchLabel.text(total.maps.L10n.ui.directions.departure);
            } else {
                storeOriginContainer.show();
                storeDestinationContainer.hide();
                firstReverseButton.show();
                secondReverseButton.hide();
                self.reverseOriginDestination = true;
                inputSearchLabel.text(total.maps.L10n.ui.directions.arrival);
            }

            self.mainElement.find(".storemap-directionlistitem-container").each(function () {
                const container = $(this);
                container.find(".storemap-active-button").removeClass("storemap-active-button");
                container.find(".storemap-directionlistitem-roadmap").hide();
                container.find(".storemap-directionlistitem-sendtomail").hide();
            });
        }

        function onGoogleMapsButtonClick(event) {
            const buttonElement = $(this);
            const summaryContainer = buttonElement.closest(".storemap-directionlistitem-container");
            const index = summaryContainer.index();

            const directionUrl = self.mainView.generateGoogleMapsDirectionUrl(index);
            window.open(directionUrl, "_blank");
            event.stopPropagation();
            EventManager.notify(event.NAVIGATION_CLICKED);
        }

        function onWazeButtonClick(event) {
            const buttonElement = $(this);
            const summaryContainer = buttonElement.closest(".storemap-directionlistitem-container");
            const index = summaryContainer.index();

            const directionUrl = self.mainView.generateWazeDirectionUrl(index);
            window.open(directionUrl, "_blank");
            event.stopPropagation();
            EventManager.notify(EVENT.NAVIGATION_CLICKED);
        }

        function onGeolocatlisationButtonClick() {
            self.mainElement.find(".storemap-inputbar-input").val("");
            self.woosmapNavigatorGeolocation.askForLocation(navigator.geolocation);
            EventManager.notify(EVENT.GEOLOCATION_CLICKED);
        }

        function onClearInputSearchButtonClick() {
            self.mainView.updateUserDirectionLocation(null);
            self.cleanDirectionData();
        }

        function onSuggestionClick(event) {
            const suggestion = $(this);
            self.mainElement.find(".storemap-inputbar-input").val(suggestion.text());
            event.stopPropagation();
        }

        this.mainElement.find(".woosmap-travel-mode-option").click(onTravelModeSpanClick);
        this.mainElement.on("click", ".storemap-directionlistitem-container", onDirectionSummaryClick);
        this.mainElement.on("click", ".storemap-directionsearchbar-reverse-button", toggleOriginDestination);
        this.mainElement.find(".storemap-directionsearchbar-reverse-button span").click(onReverseDirectionClick);
        this.mainElement.on("click", ".storemap-directionlistitem-google-button", onGoogleMapsButtonClick);
        this.mainElement.on("click", ".storemap-directionlistitem-waze-button", onWazeButtonClick);
        this.mainElement.find(".storemap-inputbar-position-button").click(onGeolocatlisationButtonClick);
        this.mainElement.find(".storemap-inputbar-clear-button").click(onClearInputSearchButtonClick);
        this.mainElement.on("click", ".woosmap-tableview-container .storemap-suggestion-item", onSuggestionClick);
    }

    show() {
        const selectedStore = this.mainView.getSelectedStore();

        this.mainElement.find("#storemap-directionlistbar-message-container").hide();

        this.directionUserPosition = this.mainView.getMainLocation();

        if (this.directionUserPosition && !$.isEmptyObject(this.directionUserPosition)) {
            if (this.directionUserPosition.description) {
                this.mainElement.find(".storemap-inputbar-input").val(this.directionUserPosition.description);
                this.mainElement.find(".storemap-inputbar-clear-button").show();
            }
            this.mainView.updateUserDirectionLocation(this.directionUserPosition);
        } else {
            this.directions = [];
        }

        if (selectedStore?.properties) {
            const logoItem = this.mainElement.find(".storemap-inputdisable-logo");
            addBrandIcon(logoItem, selectedStore);

            this.mainElement.find(".storemap-inputdisable-storename").text(selectedStore.properties.name);
            this.mainElement.find(".storemap-inputdisable-storeaddress").text(concatenateStoreAddress(selectedStore));
            this.mainView.updateDestination(selectedStore);
        }

        this._generateDirectionsList(this.directions);

        this.mainElement.show();
    }

    hide() {
        this.mainElement.hide();
    }

    predictions_changed() {
        const predictions = this.get("predictions");
        if (predictions) {
            if (predictions.length === 0) {
                this.mainElement.find(".storemap-suggestionbar-container").hide();
            } else {
                this.mainElement.find(".storemap-suggestionbar-container").show();
            }
        } else {
            this.mainElement.find(".storemap-suggestionbar-container").hide();
        }
    }

    onDirectionsChange(directions) {
        if (directions.length === 0 && !$.isEmptyObject(this.directionUserPosition)) {
            this.mainElement.find("#storemap-directionlistbar-message-container").show();
        } else {
            this.mainElement.find("#storemap-directionlistbar-message-container").hide();
            this.directions = directions;
            this._generateDirectionsList(directions);
        }
    }

    _generateDirectionsList(directions) {
        if ($.isArray(directions) && directions.length !== 0) {
            const directionItemContainer = this.mainElement.find("#storemap-directionlistbar-container");
            directionItemContainer.empty();

            const travelMode = this.mainView.getDirectionTravelMode();

            const travelModeIcon = {
                WALKING: "storemap-walk-mode",
                BICYCLING: "storemap-bike-mode",
                DRIVING: "storemap-car-mode",
                TRANSIT: "storemap-bus-mode",
            };

            directions.forEach((direction, index) => {
                const item = $($.parseHTML(templates.mobile.directionSummaryItem.render(total.maps.L10n.ui)));

                const distance = Number.parseFloat(direction.distance.split(" ")[0]) * 1000;

                item.find(".storemap-directionlistitem-distance .storemap-icon").addClass(travelModeIcon[travelMode]);
                item.find(".storemap-directionlistitem-distance-text").text(
                    `${formatDistanceValue(distance)} - ${direction.durationShort}`,
                );

                if (direction.summary === "") {
                    item.find(".storemap-directionlistitem-via").text(
                        `${total.maps.L10n.ui.directions.route} ${Number.parseInt(index, 10) + 1}`,
                    );
                } else {
                    item.find(".storemap-directionlistitem-via").text(
                        `${total.maps.L10n.ui.directions.via} ${direction.summary}`,
                    );
                }

                directionItemContainer.append(item);
            });
        }
    }

    location_changed() {
        const location = this.get("location");

        if (!$.isEmptyObject(location)) {
            const inputElement = this.mainElement.find(".storemap-inputbar-input");

            if (inputElement.val() === "") {
                inputElement.val(total.maps.L10n.ui.common.myLocation);
                this.mainElement.find(".storemap-inputbar-clear-button").show();
            }
        }

        this.mainElement.find("#storemap-directionlistbar-container").empty();
        this.mainElement.find("#storemap-directionlistbar-message-container").hide();

        if (!$.isEmptyObject(location)) this.mainView.updateUserDirectionLocation(location);
    }

    setInputSearchText() {
        this.mainElement.find(".storemap-inputbar-input").val(total.maps.L10n.ui.directions.myLocation);
        this.mainElement.find(".storemap-inputbar-clear-button").show();
    }

    cleanDirectionData() {
        this.set("location", null);
        this.directionUserPosition = null;
        this.mainElement.find(".storemap-inputbar-input").val("");
        this.mainElement.find(".storemap-inputbar-clear-button").hide();
        this.mainElement.find("#storemap-directionlistbar-container").empty();
        this.mainElement.find("#storemap-directionlistbar-message-container").hide();
    }
}
